export interface ClientRelationshipRow {
  id?: string;
  individual_id?: string;
  start_at_inclusive?: string | null;
  end_at_inclusive?: string | null;
}

export function relationshipStarted(row: ClientRelationshipRow, at: Date = new Date()): boolean {
  const raw = row.start_at_inclusive;
  if (raw === null || raw === undefined || raw === "") return true;
  const started = new Date(raw).getTime();
  return !Number.isFinite(started) || started <= at.getTime();
}

export function relationshipEnded(row: ClientRelationshipRow, at: Date = new Date()): boolean {
  const raw = row.end_at_inclusive;
  if (raw === null || raw === undefined || raw === "") return false;
  const ended = new Date(raw).getTime();
  return Number.isFinite(ended) && ended <= at.getTime();
}

export interface AdvisorClientRow {
  icId: string;
  individualId: string;
  startAt?: string | null;
}

export interface PartitionedClientRows {
  live: AdvisorClientRow[];
  ended: AdvisorClientRow[];
}

export function partitionClientRows(json: unknown, at: Date = new Date()): PartitionedClientRows {
  const rows: ClientRelationshipRow[] = Array.isArray(json) ? json : [];
  const live: AdvisorClientRow[] = [];
  const ended: AdvisorClientRow[] = [];
  for (const r of rows) {
    const icId = r.id;
    const individualId = r.individual_id;
    if (typeof icId !== "string" || icId.length === 0) continue;
    if (typeof individualId !== "string" || individualId.length === 0) continue;
    const startAt = r.start_at_inclusive ?? null;
    if (relationshipEnded(r, at)) ended.push({ icId, individualId, startAt });
    else if (relationshipStarted(r, at)) live.push({ icId, individualId, startAt });
  }
  return { live, ended };
}
